import React, { useState, useEffect, useCallback } from 'react';
import { alertSurface } from '../theme';
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import cloneDeep from 'lodash/cloneDeep';
import Collapse from '@mui/material/Collapse';
import { Card, CardActions, IconButton } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import { SnackbarContent, useSnackbar } from 'notistack';
import { _clearUnchangedFields, _getValidationPropsFromValidations } from '../helper';
import API from '../api/api';


const styles = {
  link: {
    cursor: 'pointer',
    color: 'inherit',
    textDecoration: 'underline',
  },
  actionRoot: {
    paddingLeft: '16px',
  },
  typography: {
    flex: 1,
    color: 'inherit',
  },
  wrapper: (theme) => ({
    margin: theme.spacing(1),
    position: 'relative',
  }),
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
  btn: {
    color: 'white',
  },
};

export const UpdateAppPermissionsSnackbar = React.forwardRef(({id, ...props}, ref) => {
  const { closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const onUpdate = () => {
    setLoading(true);
    API.accessUpdate((res) => {
      if(res.confirm_URL) {
        window.location.href = res.confirm_URL;
      }
      setLoading(false);
    })
  }

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);


  return <SnackbarContent ref={ref} class="error-list-snackbar">
    <Card sx={(theme) => alertSurface(theme, 'error', { opacity: 0.32 })}>
      <CardActions sx={styles.actionRoot}>
        <Typography variant="body2" sx={styles.typography}>
          <ErrorOutlineOutlinedIcon style={{marginRight: 12}} />
          {props.message}
        </Typography>
        <div>
          <span style={{ position: 'relative' }}>
            <Button
              sx={styles.btn}
              aria-label="Update"
              size="small"
              onClick={onUpdate}>
              Update
            </Button>
            {loading &&
              <CircularProgress size={24} sx={styles.buttonProgress} />
            }
          </span>
          <IconButton
            size="small"
            onClick={handleDismiss}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
      </CardActions>
    </Card>
  </SnackbarContent>
})



const UpdateAppPermissionsDialog = (props) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const access_rights = useSelector((state) => state.shop.shop.access_rights);

  useEffect(() => {
    if(access_rights && access_rights.access_lack && access_rights.access_lack.length > 0) {
      setOpen(true);
    }
  }, [access_rights])

  const onUpdate = () => {
    setLoading(true);
    API.accessUpdate((res) => {
      if(res.confirm_URL) {
        window.location.href = res.confirm_URL;
      }
      setLoading(false);
    })
  }

  const toggleDetails = () => {
    setOpenDetails(!openDetails);
  }
  
  return open ? <Alert severity="warning" 
      onClose={(e) => {setOpen(false)}} 
      style={{
        marginTop: props.marginTop ? 20 : 0,
        marginBottom: props.marginBottom ? 20 : 0,
      }}>
    <AlertTitle>{t('updateAppPermissionsDialog.title')}</AlertTitle>
    <Typography>{t('updateAppPermissionsDialog.description')}</Typography>
    {access_rights.access_lack && <div>
        <Collapse in={openDetails}>
          <Typography>{t('updateAppPermissionsDialog.detail')}</Typography>
          {access_rights.access_lack.map((accessType, i) => <Typography key={`access-type-${i}`}> - {accessType}</Typography>)}
        </Collapse>
        <Typography onClick={toggleDetails} variant={'caption'} style={{cursor: 'pointer', textDecoration: 'underline'}}>
          {!openDetails ? t('updateAppPermissionsDialog.detailShowBtn') : t('updateAppPermissionsDialog.detailHideBtn')}
        </Typography>        
      </div>
    }
    <Typography>
      <Button disabled={loading} variant="outlined" size="small" onClick={onUpdate} style={{marginTop: 8}}>
        {t('updateAppPermissionsDialog.updateBtn')}
        {loading && 
          <CircularProgress size={24} style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,}} />
        }
      </Button>    
    </Typography>
  </Alert> : null 
}
export default UpdateAppPermissionsDialog;